import styled from "styled-components"
import { Button } from "semantic-ui-react"


const StyledButton = styled(Button)`
font-family: ${({ theme }) => theme.subTitleFont}!important;
font-size: 1.2rem;
box-shadow: 0 0 0 0.1rem ${({theme}) => theme.mainColor} inset !important;
background-color: ${({theme}) => theme.bgColor} !important;
color: ${({theme}) => theme.mainColor} !important;
border: 0.05rem solid ${({theme}) => theme.mainColor} !important;


&.basic.inverted.button,
&.basic.inverted.buttons, &.button{
  font-family: ${({ theme }) => theme.subTitleFont}!important;
  font-size: 1.2rem;
  box-shadow: 0 0 0 0.1rem ${({theme}) => theme.mainColor} inset !important;
  background-color: ${({theme}) => theme.bgColor} !important;
  color: ${({theme}) => theme.mainColor} !important;
  border: 0.05rem solid ${({theme}) => theme.mainColor} !important;
  width: ${({width}) => width / 2}px !important;
}

&.basic.inverted.button:focus,
&.basic.inverted.button:hover {
  box-shadow: 0 0 0 0.14rem ${({theme}) => theme.mainColor} inset !important;
  background-color: ${({theme}) => theme.bgColor} !important;
  color: ${({theme}) => theme.mainColor} !important;
  border: 0.06rem solid ${({theme}) => theme.mainColor} !important;
}
&.basic.inverted.button:active {
  box-shadow: 0 0 0 0.16rem ${({theme}) => theme.mainColor} inset !important;
  border: 0.09rem solid ${({theme}) => theme.mainColor} !important;
}
`
export default StyledButton
